import { actionTypeCreator, stateChangeOnlyActionTypeCreator } from '../../store/actionCreators';

export const GET_ALL_NOTIFICATIONS_ACTIONTYPE = actionTypeCreator('notification/getAll');
export const MARK_NOTIFICATIONS_ACK_ACTIONTYPE = actionTypeCreator('notification/acknowledge');
export const DELETE_NOTIFICATIONS_ACTIONTYPE = actionTypeCreator('notification/delete');

export const NOTIF_SELECTED_DEVICE_ACTIONTYPE = stateChangeOnlyActionTypeCreator('notification/deviceSelect');
export const NOTIF_SELECTED_ACTIONTYPE = stateChangeOnlyActionTypeCreator('notification/notifSelect');
